<script setup lang="ts">
import { ref, onMounted, computed, onBeforeUnmount, watch } from 'vue'
import { useProductStore } from '@/stores/product';
import { useCartStore } from '@/stores/cart';
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';
import { productView, addToCartFB, genEventId  } from '@/api/fb';
import { useHead } from '@vueuse/head';
import BlackFriday from '@/components/BlackFriday.vue';
import ChristmasPromo from '@/components/ChristmasPromo.vue';

const props = defineProps({
    slug: {
        type: String,
        required: true
    }
})
const cart= useCartStore()
const router = useRouter()
const route = useRoute()
const { locale,t } = useI18n()
const product_id = computed(()=>{
    // this is the last part of the slug when separated by _
    return props.slug.split('_').pop()
})

const ProductStore = useProductStore()
const product = ref(null);
const loaded = ref(false);
const selectedArticle = ref(null)

function setProductDefault(){
    let defaultContent = {
        
    }
    

    // we navigate using the product.value.contents.fr property
    for(const [key, value] of Object.entries(product.value.content.fr)){
        if(!product.value.content[locale.value][key]){
            defaultContent[key] = value
        }
        else{
            defaultContent[key] = product.value.content[locale.value][key]
        }
    }
    product.value.content.default = defaultContent
    console.log('defaultContent',defaultContent)
    
}
// we watch the locale on change we set the default content
watch(()=>locale.value,()=>{
    setProductDefault()
})
function doGetProduct(){
    ProductStore.getProductById(product_id.value).then((res)=>{
        product.value = res
        setProductDefault()
        if(res.reload){
            // we reload the product every 5 seconds because we are missing translation
            setInterval(()=>{
                doGetProduct()
            },5000)
        }
        // we go back at the top of the page
        window.scrollTo(0,0)
        let reg = true
        if(router.currentRoute.value.query.variation){
            
            let s = selectArticle(router.currentRoute.value.query.variation)
            if(s){
                reg = false
                
                loaded.value = true
                return
            }
        }
        if(reg){
            
            if(articles.value.length==1){
                selectArticle(articles.value[0].name)
            }
            else{
                selectArticle(articles.value[0].name,true)
            }
        }
        loaded.value = true
    })
}
function trackAddToCart(product) {
  // GA4 standard event name (snake_case) so GTM can trigger the GA4 add_to_cart tag
  if(window.dataLayer){
    window.dataLayer.push({ ecommerce: null }); // clear previous ecommerce object
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'EUR',
        value: product.price,
        items: [{
          item_name: product.name,
          item_id: product.id,
          price: product.price,
          quantity: 1
        }]
      }
    });
  }
  // one shared event_id for CAPI + pixel so Meta deduplicates the two
  const eventId = genEventId();
  addToCartFB({
    name: product.name,
    id: product.id,
    price: product.price,
    quantity: 1
  }, eventId)
  if(window.fbq){
        window.fbq('track', 'AddToCart', {
        content_name: product.name,
        content_ids: [product.id],
        content_type: 'product',
        value: product.price,
        currency: 'EUR'
        }, { eventID: eventId });
    }
}

function addToCart(sArticle){
    cart.add(product_id.value,sArticle.id,1)
    trackAddToCart({
        name: productName.value+' - '+sArticle.name,
        id: sArticle.sku,
        price: sArticle.prices.discount
    })
}

// we watch the props slug to reload the product
watch(()=>props.slug,()=>{
    doGetProduct()
})

onMounted(()=>{
    doGetProduct()
})

const articles = computed(()=>{
    if(product.value){
        // we return the articles order by the int value of the name
        return product.value.articles.sort((a,b)=>parseInt(a.name)-parseInt(b.name))
    }
    return []
})
const availability = computed(()=>{
    if(selectedArticle.value){
        return availabilityText(selectedArticle.value)
    }
    return ''
})

const articlePrice = computed(()=>{
    if(selectedArticle.value){
        return selectedArticle.value.prices.discount.toFixed(2).replace('.',',')
    }
    return 'N/A €'
})
const articlePriceOfficial = computed(()=>{
    if(selectedArticle.value && selectedArticle.value.prices.official>selectedArticle.value.prices.discount){
        return selectedArticle.value.prices.official.toFixed(2).replace('.',',')
    }
    return false
})

function selectArticle(name,replace=false){
    // we find the index of the article with the name
    const index = articles.value.findIndex((article)=>article.name==name)
    if(index!=-1){
        selectedArticle.value = articles.value[index]
        // we send the event to BE
        productView(product.value,selectedArticle.value);
        // GA4 view_item — feeds GA4 funnel and Google Ads dynamic remarketing
        if(window.dataLayer){
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'view_item',
                ecommerce: {
                    currency: 'EUR',
                    value: selectedArticle.value.prices.discount,
                    items: [{
                        item_name: selectedArticle.value.name
                            ? product.value.content.default.name + ' - ' + selectedArticle.value.name
                            : product.value.content.default.name,
                        item_id: selectedArticle.value.sku,
                        price: selectedArticle.value.prices.discount,
                        quantity: 1
                    }]
                }
            });
        }
        if(product.value.articles.length>1){
            if(true){
                router.replace({query: {variation: name}})
            }
            else{
                router.push({query: {variation: name}})
            }
            useHead({
                title: selectedArticle.value.name!='' ? `${product.value.content.default.name} - ${selectedArticle.value.name}` : product.value.content.default.name
            })
        }
        window.scrollTo(0,0)
        return true
    }
    return false


}

function availabilityText(article){
    
    if(article.available){
        return t('product.delivery24')
    }
    console.log(article.delai)
    // we replace in article.delai {{between}} , {{and}}, {{days}}
    const delai = article.delai.replace(/{{between}}/g, t('product.between')).replace(/{{and}}/g, t('product.and')).replace(/{{days}}/g, t('product.days'))
    return delai
}

const productName = computed(()=>{
    if(product.value){
        let name = product.value.content.default.name
        if(articles.value.length==1){
            if(articles.value[0].name != ''){
                name += ` - ${selectedArticle.value.name}`
            }
            
        }
        return name
        
    }
    return ''
})


</script>
<template>
    <BlackFriday variant="compact" />
    <ChristmasPromo variant="compact" />
    <template v-if="loaded">
        <div id="product_page">
            <div class="product_top">
                <ProductCarousel :product="product" class="product_gallery" />
                <div class="product_info">
                    <div class="product_info_content">
                        <h1 class="mb-2">{{productName}}</h1>
                        <p v-html="product.content.default.keys.replaceAll(/\n/g, '<br />').replaceAll('\\u2022','•').replaceAll('b7','•')"></p>
                    </div>
                    <div class="product_info_to_cart mt-2 ga-2">
                        <div class="product_info_stock">
                            <div class="product_info_stock_variation" v-if="articles.length>1">
                                <p>{{$t('product.selected_version')}}</p>
                                <ProductArticleChoose :articles="articles" :selectedArticle="selectedArticle" :productName="productName" @selectArticle="selectArticle" />
                                
                            </div>
                            <div class="product_info_stock_delivery">
                                <div class="stock_status" :class="selectedArticle.available ? 'available' : 'unavailable'">{{selectedArticle.available ? $t('product.available') : $t('product.unavailable')}}</div>
                                <div class="delivery_status">{{availability}}</div>
                            </div>
                        </div>
                        <div class="product_info_price">
                            <div class="article_price">
                                <span v-if="articlePriceOfficial" class="official_price">{{articlePriceOfficial}} €</span>
                                <span>{{articlePrice}} €</span>
                            </div>
                            <z-button color="primary"  @click="addToCart(selectedArticle)">{{ $t('product.add_to_cart') }}</z-button>
                            <div class="mt-3"
                                data-pp-message
                                data-pp-style-layout="text"
                                data-pp-style-logo-type="inline"
                                data-pp-style-text-color="white"
                                data-pp-style-text-size="10"
                                :data-pp-amount="selectedArticle.prices.discount.toFixed(2)"
                                data-pp-placement=product>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="product-description">
            <div v-html="product.content.default.description"></div>
            <div v-if="product.articles.length>1">
                <h3 class="mt-3">{{$t('product.available_versions')}}</h3>
                <table class="main_available_versions">
                    <thead>
                        <tr>
                            <th>
                                {{ $t('product.version')}}
                            </th>
                            <th class="text-end">
                                {{$t('product.price')}}
                            </th>
                            <th class="text-end">
                                {{$t('product.availability')}}
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="article in product.articles" :key="article.id">
                            <td class="text-start">
                                    
                                    
                                    
                               
                                {{article.name}}
                            </td>
                            <td class="text-end">
                                <span v-if="article.prices.official > article.prices.discount" class="price_official">{{ article.prices.official.toFixed(2).replace('.','.') }}&nbsp;€</span>
                                <b>{{article.prices.discount.toFixed(2).replace('.',',')}}&nbsp;€</b>
                            </td>
                            <td class="text-end">
                                {{ article.available? $t('product.available') : $t('product.unavailable')}}
                                <v-chip class="availability" :color="article.available? 'green':'red'">
                                    <v-icon :color="article.available? 'green':'red'">{{article.available? 'mdi-cube-outline':'mdi-truck-delivery-outline'}}</v-icon>
                                    <v-tooltip location="top" activator="parent">{{ availabilityText(article) }}</v-tooltip>
                                </v-chip>
                            </td>
                            <td class="text-end">
                                <v-btn class="ma-1" color="#DC0303" size="small" @click="addToCart(article)"><v-icon icon="mdi-cart" /></v-btn>
                                <v-btn class="ma-1" size="small" @click="selectArticle(article.name)"><v-icon icon="mdi-eye" /></v-btn>

                            </td>
                            
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </template> 
</template>
<style>
:root {
    --vc-clr-primary: #C7C7C7;
    --vc-clr-secondary: #DC0303;
    --vc-nav-height: 50px;
    --vc-nav-width: 50px;
}
.product-description iframe, .product-description table{
    max-width: 100% !important;
    min-width: auto !important;
}
</style>
<style lang="scss" scoped>
.price_official{
    text-decoration: line-through;
    color: #cd1616;
    margin-right: 10px;
    font-weight: 500;
}
table.main_available_versions{
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    font-size: 0.9em;
    min-width: auto;
    max-width: 100%;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
    thead{
        tr{
            th{
                background-color: #aaa;
                word-wrap: break-word;
                color: #FFF;
                padding: 12px 5px;
                text-align: center;
                &:nth-child(3){
                    max-width: 200px;
                    width: 200px;
                }
                &:last-child{
                    max-width: 150px;
                    width: 150px;
                }
            }
        }
    }
    tbody{
        tr{
            border-bottom: 1px solid #dddddd;
            &:nth-of-type(even) {
                background-color: #f3f3f3;
            }
            &:last-child{
                border-bottom: 2px solid #DC0303;
            }
            &:hover{
                background-color: #caf8ce !important;
            }
            td{
                padding: 12px 5px;
            }
        }
    }
}
.product-description{
    width: 100%;
    padding: 20px;
    position: relative;
    box-sizing: padding-box;
    :deep(){
        p{
            font-size: 14px;
            font-family: Montserrat;
            font-weight: 400;
            color: #000;
            margin-bottom: 10px;
        }
        ul{
            margin: 0;
            li{
            margin : 0;
            margin-left: 20px;
            }
        }
        h3{
            margin-top: 10px;
        }
        iframe{
            max-width: 100% !important;
        }
        table{
            max-width: 100% !important;
            min-width: auto !important;
        }
    }
}
#product_page{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: 100%;
    .product_top{
        display: flex;
        flex-direction: column;
        position: relative;
        width: 100%;
        .product_info{
            position: relative;
            padding: 17px;
            min-height: 307px;
            color: #FFF;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            &:before{
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%; 
                height: 100%;
                z-index: -1;
                background: linear-gradient(257.47deg, #3C5A6B -8.78%, #0E2E5B 110.74%);

            }
            h1{
                font-size: 16px;
                font-family: Montserrat;
                font-weight: 700;
            }
            p{
                font-size: 14px;
            }
            .product_info_to_cart{
                display: flex;
                position: relative;
                flex-direction: column;
                .product_info_stock{
                    width: 100%;
                    display: flex;
                    position: relative;
                    justify-content: flex-end;
                    flex-direction: row;
                    .product_info_stock_variation{
                        width: 50%;
                    }
                    .product_info_stock_delivery{
                        width: 50%;
                        justify-content: space-between;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        .stock_status, .delivery_status{
                            font-family: Montserrat;
                            font-weight: 700;
                            font-size: 14px;
                            letter-spacing: 0%;
                            &.available{
                                color: #5ED880;
                            }
                            &.unavailable{
                                color: #FF0000;
                            }

                        }
                    }

                }
                .product_info_price{
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    margin-top: 10px;
                    .article_price{
                        width: 100%;
                        text-align: center;
                        font-family: Montserrat;
                        font-weight: 700;
                        font-size: 18px;
                        line-height: 21.94px;
                        letter-spacing: 0%;
                        color: #FFF;
                        .official_price{
                            text-decoration: line-through;
                            //color: #cd1616;
                            margin-right: 10px;
                            font-weight: 500;

                        }
                    }
                }

            }
            table{
                width: 100%;
                thead{
                    th{
                        font-size: 14px;
                        font-family: Montserrat;
                        font-weight: 500;
                        color: #FFF;
                        padding: 2px 5px;
                        border: 1px solid #FFF;
                        &:last-child{
                            width: 100px;
                        }
                        
                    }
                }
                tbody{
                    tr{
                        gap:0;
                        td{
                            position: relative;
                            font-size: 14px;
                            font-family: Montserrat;
                            
                            padding: 2px 5px;
                            font-weight: 400;
                            color: #FFF;
                            border-bottom: 1px solid #FFF;
                            &:last-child{
                                width: 30px;
                            }
                            &:nth-child(2){
                                text-align: right;
                            }
                            &:nth-child(3){
                                width: 50px;
                            }
                        }
                        &:hover{
                                background-color: #00000040;
                            }
                    }
                }
            }
        }
        .product_gallery{
            width: 100%;
            height: 257px;
        }
    }
    
}
@media only screen and (min-width : $responsive-point) {
    .product-description{
        width: $responsive-point;
        margin: 0 auto;
    }
    #product_page{
        position: relative;
        width: $responsive-point;
        margin: 0 auto;
        flex-wrap: wrap;
        .product_top{
            flex-direction: row;
            width: 100%;
            .product_info{
                width: 50%;
                order: 1;
                &:before{
                    left: calc(100% - (100vw / 2));
                    width: calc(100vw / 2); 
                }
                .product_info_to_cart{
                    flex-direction: row;
                    .product_info_stock{
                        width: 50%;
                        flex-direction: column;
                        .product_info_stock_variation{
                            width: 100%;
                        }
                        .product_info_stock_delivery{
                            width: 100%;
                            margin-top: 5px;
                            align-items: flex-start;
                        }
                    }
                    .product_info_price{
                        width: 50%;
                    }
                }
            }
            .product_gallery{
                
                width: 50%;
                order: 2;
                height: auto;
            }
        }
    }
    
    
}
</style>
<route lang="yaml">
    name: product
    props: true
    meta:
        title: Produit KaseFilters
        layout: default
        description: Découvrez ce produit KaseFilters
        middleware: guest
    </route>